import { InfiniteList } from "components/list/infinity-list";
import { Box } from "@mui/material";
import UserAvatar from "components/card/UserAvatar";
import { IGrantVestmentFollower } from "interfaces/grant-vestment-follower";
interface GrantVestmentFollowersListProps {
  grantVestmentId: number;
}

export const GrantVestmentFollowersList: React.FC<
  GrantVestmentFollowersListProps
> = ({ grantVestmentId }) => {
  return (
    <Box>
      <InfiniteList<IGrantVestmentFollower>
        endpoint={`grantvestment-follower`}
        queryParams={{ "filter[grantvestmentId]": `${grantVestmentId}` }}
        isTable={true}
        limit={5}
        columns={[
          {
            field: "user",
            header: "Followers",
            renderCell: function render({ user }) {
              return <UserAvatar user={user} />;
            },
          },
        ]}
        tableProps={{
          stickyHeader: true,
          headerBgColor: "grey.200",
          responsive: true,
        }}
      />
    </Box>
  );
};
